export default {
  /**
   * Sets the order changes information onto the state.
   *
   * @param {Object} state
   * @param {Object|null} changes
   */
  SET(state, changes) {
    state.changes = changes
  },
}
